module.exports = __webpack_public_path__ + "img/img12.46c6e9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/07/img12.jpg
// module id = 277
// module chunks = 0